import {
  getRequest,
  checkStatus,
  parseStatusAndBody,
  postRequest,
} from "helpers/requests";

import { HQ_WORKFORCE_SERVICE } from "constants/app";

interface IEnforcementSettings {
  enforcementOn: boolean;
  gracePeriod: number;
  updatedAt: string;
}

function getEnforcementSettings(
  permalink: string
): Promise<IEnforcementSettings> {
  return fetch(
    `${HQ_WORKFORCE_SERVICE}/${permalink}/settings/enforcement`,
    getRequest()
  )
    .then((response) => parseStatusAndBody<IEnforcementSettings>(response))
    .then((parsedResponse: [number, IEnforcementSettings]) =>
      checkStatus<IEnforcementSettings>(parsedResponse)
    );
}

function postEnforcementSettings(
  permalink: string,
  enforcementOn: boolean,
  gracePeriod: number
): Promise<IEnforcementSettings> {
  return fetch(
    `${HQ_WORKFORCE_SERVICE}/${permalink}/settings/enforcement`,
    postRequest({ enforcementOn, gracePeriod })
  )
    .then((response) => parseStatusAndBody<IEnforcementSettings>(response))
    .then((parsedResponse: [number, IEnforcementSettings]) =>
      checkStatus<IEnforcementSettings>(parsedResponse)
    );
}

export {
  getEnforcementSettings,
  IEnforcementSettings,
  postEnforcementSettings,
};
